import { ErrorPageLayout } from '../layout/ErrorPageLayout.js';

export const NotFoundElement = () => {
  return (
    <ErrorPageLayout
      title="We're sorry, the page you requested cannot be found."
      body="The URL may be misspelled or the page you're looking for is no longer available."
    />
  );
};
